import type { Maybe, ProductImage, ProductVideo } from '@pylot-data/pylotschema'
import Image from '@corratech/pylot-image'
import dynamic from 'next/dynamic'
import { useDevice } from '@corratech/pylot-utils'

const ZoomImage = dynamic(() => import('@corratech/pylot-zoom-image'))
const PrismaZoom = dynamic(() => import('react-prismazoom'))

type ImageSlidePropTypes = {
    image: Maybe<ProductVideo | ProductImage>
    productImageAlt: string
    width: number
    height: number
    index: number
    zoom: boolean
    showFullscreen: boolean
    s: {
        [key: string]: string
    }
    openFullscreen: (i: number) => void
}

const ImageSlide = (props: ImageSlidePropTypes) => {
    const {
        image,
        productImageAlt,
        width,
        height,
        index,
        zoom,
        showFullscreen,
        s,
        openFullscreen
    } = props

    const { isTouch } = useDevice()

    const zoomSlide = (
        img: Maybe<ProductVideo | ProductImage>,
        imageAlt: string,
        imgWidth: number,
        imgHeight: number,
        slideIndex: number
    ) => {
        return isTouch() ? (
            <PrismaZoom>
                {slide(img, imageAlt, imgWidth, imgHeight, slideIndex)}
            </PrismaZoom>
        ) : (
            <ZoomImage
                alt={img?.label || imageAlt}
                src={img?.url ?? ''}
                zoomSrc={`${img?.url}?width=2000` ?? ''}
            />
        )
    }

    const slide = (
        img: Maybe<ProductVideo | ProductImage>,
        imageAlt: string,
        imgWidth: number,
        imgHeight: number,
        slideIndex: number
    ) => {
        return (
            <Image
                className={s['img']}
                src={img?.url ?? ''}
                alt={img?.label || imageAlt}
                objectFit="contain"
                width={imgWidth}
                height={imgHeight}
                priority={slideIndex === 0}
                quality="85"
                onClick={() => {
                    showFullscreen && openFullscreen(slideIndex)
                }}
            />
        )
    }

    return zoom
        ? zoomSlide(image, productImageAlt, width, height, index)
        : slide(image, productImageAlt, width, height, index)
}

export default ImageSlide
